const TripDistanceRoundOff = (distance) => {
  // const roundOff=Math.ceil((distance / 1000) * 10) / 10
  const roundOff = Math.ceil(distance / 1000);

  return roundOff;
};
export default TripDistanceRoundOff;
